import { render, staticRenderFns } from "./Contatto.vue?vue&type=template&id=d5e0dff2"
import script from "./Contatto.vue?vue&type=script&lang=js"
export * from "./Contatto.vue?vue&type=script&lang=js"
import style0 from "./Contatto.vue?vue&type=style&index=0&id=d5e0dff2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports